const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-c-calendar-date-seasons">
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(new Map([[0, `2020-04-01`], [1, `2020-07-04`], [2, `2020-10-31`], [3, `2020-12-31`]]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`datetime`] = __value__;
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/calendar-date/calendar-date.twig`, undefined, true, false, 3));
                    this.echo(`  `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('datetime');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `05f59e79b792a62b6a7e22e558ecf0811d8af7f9745ea9fb035d82f8cc07d078`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `05f59e79b792a62b6a7e22e558ecf0811d8af7f9745ea9fb035d82f8cc07d078`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '05f59e79b792a62b6a7e22e558ecf0811d8af7f9745ea9fb035d82f8cc07d078');

let template = env.loadTemplate('05f59e79b792a62b6a7e22e558ecf0811d8af7f9745ea9fb035d82f8cc07d078');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/calendar-date/demo/seasons.twig", args: context }
     );
     return rendered;;
};